import { useQuery } from '@tanstack/react-query';
import { http } from 'services/http';
import type { TGetWaypointsCoordinatesRes } from 'api/swagger';
import { CLIENT_CARGO_GEO } from '../query-keys';

interface IParams {
  enabled: boolean;
}

export const useGetClientCargoGeo = (cargoId: number, options: IParams) => {
  const { enabled } = options;
  return useQuery<TGetWaypointsCoordinatesRes>({
    queryKey: [CLIENT_CARGO_GEO, cargoId],
    queryFn: async () => {
      const { data } = await http.get<TGetWaypointsCoordinatesRes>(`/client-office/v1/cargoes/${cargoId}/geo`);

      return data;
    },
    retry: false,
    refetchOnWindowFocus: false,
    enabled,
  });
};
